<template>
  <div class="download-mobile-root">
    <div class="container" v-show="!hasError" v-loading="isLoading">
      <div class="app-info mid" v-show="!isLoading">
        <img
          class="weixin-text"
          src="/assets/images/weixintootiptext.png"
          v-show="isWeiXin"
        />
        <img class="logo" :src="logoUrl" />
        <div class="app-name">{{ appName }}</div>
        <div class="app-size" style="margin-top: 15pt">{{ appSize }}</div>
        <div class="app-version">{{ appVersion }}</div>
        <div class="app-update">{{ appUpdate }}</div>
        <div class="download-button" @click="handleDownload">
          <i
            :class="['platform', 'iconfont', 'icon-' + iconEnum[platform]]"
          ></i>
          &nbsp;下载安装
        </div>
      </div>
    </div>
    <div class="container error-tip" v-show="hasError"></div>

    <el-dialog
      v-model="dialogVisible"
      title="请输入密码"
      width="300px"
      top="35vh"
      :close-on-click-modal="false"
    >
      <el-input v-model="password" v-tc-auto-focus="dialogVisible" />
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="handleConfirm">确定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { getCurrentInstance, onMounted, ref, watch, defineProps } from "vue";
import { apiGetAppInfoByUri, apiGetPackageUrl } from "@/Api/AppApi";
import { humanSize } from "@/Utils/UtilTools";

const props = defineProps(["uri", "isWeiXin"]);

const { appContext } = getCurrentInstance();
const $moment = appContext.config.globalProperties.$moment;
const $message = appContext.config.globalProperties.$message;

const errorMessage = ref("");
const hasError = ref(false);
let uri = "";
watch(
  () => props.uri,
  (val) => {
    if (!val) {
      errorMessage.value = "缺少app短链";
      hasError.value = true;
      return;
    }
    hasError.value = false;

    uri = val;
    getAppInfo();
  },
  { immediate: true }
);
onMounted(() => {
  if (props.uri) {
    hasError.value = false;
    uri = props.uri;
    getAppInfo();
  } else {
    hasError.value = true;
    errorMessage.value = "缺少app短链";
  }
});

const iconEnum = ["apple", "android", "windows", "app-store", "linux"];

const isLoading = ref(false);
const logoUrl = ref("");
const appName = ref("");
const appSize = ref("");
const appVersion = ref("");
const appUpdate = ref("");
const platform = ref(0);
let app = null;
async function getAppInfo() {
  isLoading.value = true;
  const res = await apiGetAppInfoByUri(uri);
  isLoading.value = false;
  if (res.code === 0) {
    app = res.data;
    initDataShow();
  } else {
    hasError.value = true;
    if (res.code === 28) {
      errorMessage.value = "没有找到对应的app";
    } else {
      errorMessage.value = res.message;
    }
  }
}
function initDataShow() {
  const release = app.releaseversion || {};
  const pack = release.package || {};

  logoUrl.value = pack.logo || app.logourl;
  appName.value = pack.appname || app.appname;
  appSize.value = humanSize(pack.size, 1);
  appVersion.value = `${pack.version} (BUILD ${pack.buildnumber})`;
  appUpdate.value = `更新于${$moment(release.createtime).format(
    "YYYY/MM/DD HH:mm"
  )}`;

  platform.value = app.platform - 1;
}

const password = ref("");
const dialogVisible = ref(false);
function handleDownload() {
  if (app.password === "true") {
    dialogVisible.value = true;
  } else {
    doDownload();
  }
}
function handleConfirm() {
  if (password.value.length > 0) {
    dialogVisible.value = false;
    doDownload();
  } else {
    $message({ type: "warning", message: "密码为空，请输入密码。" });
  }
}

async function getPackageUrl() {
  const release = app.releaseversion;
  const versionId = release.id;
  let res;

  const data = {
    id: versionId,
    password: password.value,
    activityid: "",
  };
  res = await apiGetPackageUrl(data);

  if (res.code === 0) {
    return res.data;
  } else if (res.code === 30000) {
    $message({
      type: "error",
      message: "密码错误，请重新输入密码。",
    });
  } else {
    $message({
      type: "error",
      message: res.message,
    });
  }
}

let downloading = false;
async function doDownload() {
  if (downloading) {
    return;
  }

  downloading = true;
  const url = await getPackageUrl();
  downloading = false;
  if (url) {
    const node = document.createElement("a");
    node.href = url;
    node.click();
    node.remove();
  }
}
</script>

<style lang="scss" scoped>
.download-mobile-root {
  width: 100%;
  height: 100%;
  position: relative;
}

.container {
  width: 100%;
  height: 100%;
  font-family: NotoSansHans-Medium, PingFangSC-Medium, "Microsoft YaHei",
    微软雅黑;
}

.mid {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.weixin-text {
  width: 89%;
  height: auto;
  position: absolute;
  top: 0;
}

.logo {
  width: 90pt;
  height: 90pt;
  border-radius: 15pt;
}

.app-name {
  font-size: 13pt;
  color: #fff;
  margin-top: 15pt;
}

.app-size,
.app-version,
.app-update {
  font-size: 9pt;
  color: #0d84e5;
  opacity: 0.4;
  margin-top: 8pt;
}

.download-button {
  width: 140pt;
  height: 40pt;
  color: #fff;
  font-size: 16pt;
  margin: 30pt 0;
  cursor: pointer;
  text-align: center;
  line-height: 40pt;
  vertical-align: middle;
  border-radius: 6pt;
  user-select: none;
  background-color: #0d84e5;
}
</style>
